// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1533ce67","761":"9612a9d5"}[chunkId] + ".chunk.js";
};